import type {
  PageContext,
} from 'vike/types';

export function onBeforeRender(pageContext: PageContext) {
  const {
    platform,
    isHydration,
  } = pageContext;

  if (
    isHydration
  ) pageContext.globalContext.platform = platform;

  pageContext.platform = pageContext.globalContext.platform;
}
